import React from "react";
import "./index.css";
import { App } from "./App2";
import { Login } from "./login/Login";
import { SignUp } from "./login/SignUp";
import { SocialLogin } from "./login/SocialLogin";
import { ErrorPage } from "./error/errorPage";

import { Item } from "./item/ItemPage";

import { ViewItem } from "./item/ViewItem";
import { BasketList } from "./basket/BasketList";

import { API } from "./api/API";
import { AllUser } from "./api/All";
import { TodoList } from "./api/TodoList";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Typography, Box } from "@mui/material";

import { Admin } from "./admin/Admin";
import { Home } from "./home/home";
import { Pay, Completed, Fail, Cancel, PayServer } from "./pay/Proxy";

import { Lotto } from "./lotto/Lotto.js";
import { Upbit } from "./lotto/Upbit.js";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      nc software engineer, {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// <Route path="/" element={<App />} />
const AppRouter = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="home" element={<Home />} />

          <Route path="todo" element={<App />} />
          <Route path="login" element={<Login />} />
          <Route path="SignUp" element={<SignUp />} />
          <Route path="errorPage" element={<ErrorPage />} />
          <Route path="sociallogin" element={<SocialLogin />} />

          <Route path="item" element={<Item />} />
          <Route path="viewItem" element={<ViewItem />} />
          <Route path="basketlist" element={<BasketList />} />

          <Route path="api" element={<API />} />
          <Route path="api/all" element={<AllUser />} />
          <Route path="api/item" element={<TodoList />} />

          <Route path="admin" element={<Admin />} />

          <Route path="pay" element={<Pay />} />
          <Route path="pays" element={<PayServer />} />

          <Route path="lotto" element={<Lotto />} />

          <Route path="upbit" element={<Upbit />} />

          <Route path="pay/completed" element={<Completed />} />
          <Route path="pay/fail" element={<Fail />} />
          <Route path="pay/cancel" element={<Cancel />} />
        </Routes>
      </BrowserRouter>
      <Box mt={5}>
        <Copyright />
      </Box>
    </div>
  );
};

export default AppRouter;
